<template>
  <b-row class="pr-3">
    <b-col cols="12" class="mb-2">
      <PageTitle title="Integrar produtos/pedidos com a Tiny" />
    </b-col>

    <b-col cols="12">
      <span class="text-white" v-observe-visibility="menuPosition">...</span>
      <span class="text-white" v-observe-visibility="menuPositionOne">...</span>

      <h4>Dados de integração com a Tiny</h4>
    </b-col>

    <b-col cols="12" class="mb-2">
      <label>Identificador do integrador:</label>
      <input type="text" class="form-control" v-model="data.identifier" placeholder="#####">
    </b-col>

    <b-col cols="12" class="mb-2">
      <label>Token:</label>
      <input type="text" class="form-control" v-model="data.token" placeholder="######################">
    </b-col>

    <b-col cols="12" class="mb-2">
      <label>Endpoint para cotação de fretes:</label>
      <input type="text" class="form-control" v-model="data.endpoint_freight" placeholder="https://erp.tiny.com.br/webhook/api/v1/parceiro/######/cotar">
    </b-col>

    <b-col cols="12" class="text-center mt-4 mb-4">
      <button class="btn btn-success pl-4 pr-4" @click="saveData()">Salvar dados</button>
    </b-col>

    <b-col cols="12" v-if="data.token && data.token != ''">
      <b-row>
        <b-col cols="12" class="mt-4 mb-4">

          <h4 class="mb-0">Produtos</h4>

          <b-row>
            <b-col cols="12" class="mb-2 mt-0">
              <PeriodsFilters
                ref="periodsFilters"
                :setDatesAutomatic="false"
                :startDate.sync="startDate"
                :endDate.sync="endDate"
                :limparDados="limpar"
                @click.native="filterDate()"
              />
            </b-col>

            <b-col cols="12" class="mt-2">
              <span 
                :class="filters.tiny == 1 ? 'badge badge-primary statusTiny' : 'badge badge-light statusTiny'"
                @click="setStatusTiny(1)"
              >
                Ativo
              </span>
              <span 
                :class="filters.tiny == 2 ? 'badge badge-primary statusTiny' : 'badge badge-light statusTiny'"
                @click="setStatusTiny(2)"
              >
                Inativo
              </span>
              <span 
                :class="filters.tiny == 3 ? 'badge badge-primary statusTiny' : 'badge badge-light statusTiny'"
                @click="setStatusTiny(3)"
              >
                Aguardando para ativar
              </span>
              <span 
                :class="filters.tiny == 4 ? 'badge badge-primary statusTiny' : 'badge badge-light statusTiny'"
                @click="setStatusTiny(4)"
              >
                Aguardando para inativar
              </span>
              <span 
                :class="filters.tiny == 5 ? 'badge badge-primary statusTiny' : 'badge badge-light statusTiny'"
                @click="setStatusTiny(5)"
              >
                Aguardando para atualizar
              </span>
              <span 
                :class="filters.tiny == 'all' ? 'badge badge-primary statusTiny' : 'badge badge-light statusTiny'" 
                @click="setStatusTiny('all')"
              >
                Todos
              </span>
            </b-col>

            <b-col cols="12" class="mt-3">
              <input
                @keyup.enter="get()"
                type="text"
                class="form-control"
                v-model="filters.name"
                placeholder="Nome do produto, código de barras, marca"
              />
            </b-col>

            <b-col cols="12" class="mt-3">
              <b-button variant="success" @click="get()" :disabled="loading">
                <i class="fas fa-search mr-2"></i>
                Pesquisar
              </b-button>

              <b-button variant="warning" class="ml-2" @click="cleanSelection()">
                <i class="fas fa-trash mr-2"></i>
                Limpar
              </b-button>
            </b-col>
          </b-row>
          
          <span class="text-white" v-observe-visibility="menuPositionTwo">.</span>   
        </b-col>

        <b-col cols="12">
          <div class="alert alert-primary text-center cursor-pointer" role="alert" @click="acaoProdutos(3)">
            CLIQUE AQUI PARA ENVIAR TODOS OS PRODUTOS PARA A TINY
          </div>

          <div class="alert alert-danger text-center cursor-pointer" role="alert" @click="acaoProdutos(4)">
            CLIQUE AQUI PARA REMOVER TODOS OS PRODUTOS DA TINY
          </div>
        </b-col>

        <span class="text-white" v-observe-visibility="pagePosition">...</span>

        <b-col cols="12" style="padding-bottom: 50px;">
          <b-table
            striped
            bordered
            hover
            thead-class
            show-empty
            responsive
            fixed
            empty-text="Sem produtos encontrados"
            :fields="table.headers"
            :items="table.records"
            :tbody-tr-class="validItens"
            :thead-tr-class="'position: sticky'"
          >
            <template #head()="data">
              <thead class="p-0 m-0">
                <tr class="p-0 m-0">
                  <th :class="!menuVisibleOne && !menuVisibleTwo ?  'headTableFixed': 'headTable'">
                    {{ data.label }}
                  </th>
                </tr>
              </thead>
            </template>

            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Carregando...</strong>
              </div>
            </template>

            <template #cell(priceSalesFormat1)="data">
              <span>{{ formatNumber(data.item.priceSalesFormat1) }}</span>
            </template>

            <template #cell(googleShopping)="data">
              <b-form-checkbox
                v-if="data.item.status != 2"
                v-model="data.item.tinyCheck"
                @change="save(data.item.id, data.item.tinyCheck)"
                switch
              >
                {{ data.item.tinyCheck ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </template>

            <template #cell(photo)="data">
              <span @click="showModal(data.item.productId, data.item.product, data.item.selectedAt)">
                <img :src="linkFotos(data.item.origem) + data.item.photo" :alt="data.item.product" class="imgWidth">
              </span>
            </template>

            <template #cell(product)="data">
              <span class="spanProduct">
                {{ data.item.product }}
              </span>
            </template>

            <template #cell(statusTiny)="data">
              <div v-if="data.item.tiny" class="text-center">
                <span class="badge badge-success" v-if="data.item.tiny.status == 1">Ativo</span>
                <span class="badge badge-danger" v-if="data.item.tiny.status == 2">Inativo</span>
                <span class="badge badge-primary" v-if="data.item.tiny.status == 3">Aguardando para ativar</span>
                <span class="badge badge-warning" v-if="data.item.tiny.status == 4">Aguardando para inativar</span>
                <span class="badge badge-dark" v-if="data.item.tiny.status == 5">Aguardando para atualizar</span>
              </div>
            </template>

            <template #cell(codbar)="data">
              <b-badge>
                {{  data.item.codbar }}
              </b-badge>
            </template>

            <template #cell(quantityStock)="data">
              {{ data.item.quantityValid ? ' Sim' : ' Não' }}
            </template>

            <template #cell(codInternoAdd)="data">
              <span>{{ data.item.codInterno ? data.item.codInterno : '-' }}</span>
            </template>
          </b-table>
        </b-col>

        <div v-observe-visibility="visibilityChanged">Carregando...</div>

        <b-modal
          ref="detalhesProduto"
          size="xl"
          centered
          hide-footer
          :title="productModal"
          header-bg-variant="orange"
          header-text-variant="light"
        >
          <b-row>
            <b-col cols="5" class="slideImg">
              <b-carousel
                style="text-shadow: 0px 0px 2px #000"
                indicators
                img-width="600"
                img-height="600"
                controls
                sliding-start
                sliding-end
                v-if="detalhesP.fotos.length > 0"
              >
                <b-carousel-slide v-for="(item, i) in detalhesP.fotos" :key="i"
                  :img-src="linkFotos(detalhesP.produto.origem) + item.foto_png"
                ></b-carousel-slide>
              </b-carousel>

              <div v-else>
                <h1>Sem imagens</h1>
              </div>
            </b-col>

            <b-col cols="7">
              <div class="accordion" role="tablist" v-if="detalhesP.produto != null">

                <b-card-header class="text-center">
                  <h4>{{ detalhesP.produto.departamentos }}</h4>
                </b-card-header>

                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-1 variant="success">Detalhes</b-button>
                  </b-card-header>

                  <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-row>
                        <b-col cols="12" class="mb-2">
                          <label>Produto:</label>
                          <input type="text" :value="detalhesP.produto.produto" class="form-control" readonly>

                          <div v-if="productSelectedAt" class="fs-14 text-secondary">
                            (Selecionado em {{ productSelectedAt }})
                          </div>
                        </b-col>

                        <b-col cols="4" class="mb-2">
                          <label>Marca:</label>
                          <input type="text" :value="detalhesP.produto.marca" class="form-control" readonly>
                        </b-col>

                        <b-col cols="4" class="mb-2">
                          <label>Cod. barras:</label>
                          <input type="text" :value="detalhesP.produto.codbar" class="form-control" readonly>
                        </b-col>

                        <b-col cols="4" class="mb-2">
                          <label>Dimensões:</label>
                          <input type="text" :value="detalhesP.produto.dimensoes" class="form-control" readonly>
                        </b-col>

                        <b-col cols="12" class="mb-2">
                          <label>Descrição:</label>
                          <textarea
                            type="text"
                            :value="detalhesP.produto.descricao"
                            class="form-control"
                            rows="3"
                            readonly
                          ></textarea>
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1" v-if="detalhesP.fichas.length > 0">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-2 variant="info">Ficha técnica</b-button>
                  </b-card-header>

                  <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                    <b-card-body class="scrollDiv">
                      <b-row v-for="(item, i) in detalhesP.fichas" :key="i">
                        <b-col cols="4" class="mb-2">
                          <input type="text" :value="item.tipo" class="form-control" readonly>
                        </b-col>

                        <b-col cols="8" class="mb-2">
                          <input type="text" :value="item.descricao" class="form-control" readonly>
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
        </b-modal>
      </b-row>
    </b-col>

  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';
import PageTitle from 'Components/PageTitle.vue';
import ProductsFilters from '../products/ProductsFilters.vue';
import PeriodsFilters from '@/components/Inputs/PeriodsFilters.vue';
import UserTypes from '@/enums/UserTypes';

export default {
  name: 'tiny',
  mixins: [makeToast],

  components: {
    PageTitle,
    ProductsFilters,
    PeriodsFilters
  },

  data() {
    return {
      loading: false,
      typeProducts: 'geral',
      productSelectedAt: '',
      productModal: '',
      startDate: '',
      endDate: '',
      limpar: false,
      btnVisible: false,
      menuVisible: false,
      menuVisibleOne: false,
      menuVisibleTwo: false,
      data: {
        identifier: '',
        token: '',
        endpoint_freight: '',
      },
      detalhesP: {
        fotos: [],
        fichas: [],
        produto: null,
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 1,
        lastPage: 1
      },
      filters: {},
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'productId',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'googleShopping',
            label: 'Tiny',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
            thStyle: 'width: 150px;',
            tdStyle: 'width: 150px;',
          },
          {
            key: 'photo',
            label: 'Detalhes',
            sortable: true,
            thClass: 'text-center fs-14',
            tdClass: 'text-center',
            thStyle: 'width: 80px;',
            tdStyle: 'width: 80px;',
          },
          {
            key: 'product',
            label: 'Produto',
            sortable: true,
            thClass: 'fs-14',
          },
          {
            key: 'statusTiny',
            label: 'Status Tiny',
            sortable: true,
            thClass: 'fs-14',
            thStyle: 'width: 180px;',
            tdStyle: 'width: 180px;',
          },
          {
            key: 'marca',
            label: 'Marca',
            sortable: true,
            thClass: 'text-center fs-14 d-none d-lg-table-cell',
            tdClass: 'text-center d-none d-lg-table-cell',
            headerClass: "d-none d-lg-table-cell", 
            thStyle: 'width: 120px;',
            tdStyle: 'width: 120px;',
          },
          {
            key: 'codbar',
            label: 'Cod. barras',
            thClass: 'fs-14 d-none d-lg-table-cell',
            tdClass: "d-none d-lg-table-cell",
            headerClass: "d-none d-lg-table-cell", 
            sortable: true,
            thStyle: 'width: 130px;',
            tdStyle: 'width: 130px;',
          },
          {
            key: 'priceSalesFormat1',
            label: 'Preço',
            sortable: true,
            thClass: 'text-center fs-14',
            tdClass: 'text-center ',
            thStyle: 'width: 150px;',
            tdStyle: 'width: 150px;',
          },
          {
            key: 'quantityStock',
            label: 'Estoque',
            sortable: true,
            thClass: 'text-center fs-14 d-none d-lg-table-cell',
            tdClass: 'text-center d-none d-lg-table-cell',
            headerClass: "d-none d-lg-table-cell", 
            thStyle: 'width: 80px;',
            tdStyle: 'width: 80px;',
          },
          {
            key: 'codInternoAdd',
            label: 'Cod. I.',
            sortable: true,
            thClass: 'text-center fs-14 d-none d-lg-table-cell',
            tdClass: 'text-center d-none d-lg-table-cell',
            headerClass: "d-none d-lg-table-cell", 
            thStyle: 'width: 80px;',
            tdStyle: 'width: 80px;',
          }
        ],
        records: [],
      }
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  watch: {
    'pagination.currentPage': function () {
      this.get();
    },
  },

  created() {
    this.getTiny();
  },

  methods: {
    getTiny() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getTiny', this.userTypeId())
        .then((response) => {
          if(response.data.token) {
            this.data = response.data;
            this.get();
          }
        }).catch((e) => {
          this.makeToast('Opss!', "Erro ao buscar dados!", 'danger');
        }).finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    setStatusTiny(status = '') {
      this.table.records = [];
      this.filters.tiny = status;

      this.get();
    },
    saveData() {
      this.data.construp_user_id = this.userTypeId();

      if(this.data.token == '' || this.data.identifier == '' || this.data.endpoint_freight == '') {
        this.makeToast('Opss!', "Informe todos os campos para salvar!", 'danger');
        return;
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/saveTiny', this.data)
        .then(() => {
          this.makeToast('Sucesso', "Dados atualizado com sucesso!", 'success');
          this.table.records = [];
          this.getTiny();
        }).catch((e) => {
          this.$store.dispatch('endLoader');
          this.makeToast('Opss!', "Erro ao atualizar dados!", 'danger');
        });
    },
    acaoProdutos(acao) {
      const data = {
        status: acao,
        construp_user_id: this.userTypeId()
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/saveProductAllTiny', data)
        .then(() => {
          this.makeToast('Sucesso', "Produto(s) atualizado com sucesso!", 'success');
          this.table.records = [];
          this.getTiny();
        }).catch((e) => {
          this.$store.dispatch('endLoader');
          this.makeToast('Opss!', "Erro ao atualizar produto(s)!", 'danger');
        });
    },
    save(id, status) {
      const data = {
        id: id,
        status: status == true ? 3 : 4
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/saveProductTiny', data)
        .then(() => {
          this.makeToast('Sucesso', "Produto atualizado com sucesso!", 'success');
          this.table.records = [];
          this.getTiny();            
        }).catch(() => {
          this.makeToast('Opss!', "Erro ao atualizar produto!", 'danger');
        }).finally(() => {
          this.$store.dispatch('endLoader');
        })
    },

    showModal(productId, product, selectedAt = '') {
      this.productModal = product;
      this.productSelectedAt = selectedAt;

      this.buscarDetalhesGerais(productId);      
    },

    buscarDetalhesGerais(productId) {
      this.$store.dispatch('startLoader');

      const data = {
        productId: productId,
        lojistaId: this.userTypeId()
      }

      this.$store.dispatch('shopkeeper/getDetalhesProdutoGeral', data)
        .then((response) => {
          this.detalhesP.fichas = response.data.ficha;
          this.detalhesP.fotos = response.data.fotos;
          this.detalhesP.produto = response.data.produto;
          this.$refs['detalhesProduto'].show();
        })
        .catch(() => {
          this.makeToast('Opss', 'Erro ao buscar detalhes do produto!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },

    cleanSelection() {
      this.filters = {};
      this.table.records = [];
      this.get();
    },

    pagePosition(isVisible) {
      this.btnVisible = isVisible;
    },
    menuPosition(isVisible) {
      this.menuVisible = isVisible;
    },

    formatNumber(number) {
      return Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
      }).format(number);
    },

    linkFotos(origem) {
      if (origem == 'Belenus' || origem == 'fixadores') {
        return 'https://storage.googleapis.com/fotos-prd/';
      } else {
        return process.env.VUE_APP_FOTOS_URL;
      }
    },

    validItens(item) {
      if (item != null && item.status == 2) {
        return 'lineDanger';
      }
    },

    visibilityChanged(isVisible) {
      if (!isVisible || this.loading == true) return;
      if (this.pagination.lastPage >0 && this.pagination.currentPage >= this.pagination.lastPage) return;
      this.pagination.currentPage = this.pagination.currentPage + 1;
    },

    menuPositionOne(isVisible) {
      this.menuVisibleOne = isVisible;
    },

    menuPositionTwo(isVisible) {
      this.menuVisibleTwo = isVisible;
    },

    get() {
      if (this.loading) return;

      if (this.filters.name) {
        this.startDate = '';
        this.endDate = '';
        this.table.records = [];
        this.pagination.currentPage = 1;
      }

      this.loading = true;
      this.$store.dispatch('startLoader');
      
      this.$store.dispatch('shopkeeper/getSelectedProducts', {
        userId: this.userTypeId(),
        productName: this.filters.name,
        currentPage: this.pagination.currentPage,
        familyId: this.filters.family,
        typeProducts: this.typeProducts,
        startDate: this.startDate,
        endDate: this.endDate,
        status: this.buscaInativo ? 'inativo' : '',
        isTiny: true,
        tinyStatus: this.filters.tiny,
      })
        .then((response) => {
          const { perPage, total, lastPage } = response.data.data || {};
          this.pagination.itemsPerPage = perPage || 15;
          this.pagination.total = total;
          this.pagination.lastPage = lastPage;
          this.table.records.push(...response.data.data.data);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
  }
}
</script>

<style>
.imgWidth {
  width: 50px;
  cursor: pointer;
}
.slideImg {
  display: flex;
  justify-content: center;
  align-items: center;
}
.scrollDiv {
  overflow: scroll;
  height: 300px;
}
.headTableFixed{
  background: rgb(255, 255, 255);
  z-index: 1;
  position: fixed;
  width:100vw;
  height: 60px;
  top: 49px;
  margin-left: -13px;
  text-align: start;
}
.headTable{
  background: white;
  border: none !important;
  padding: 0 !important;
}
.statusTiny {
  cursor: pointer;
  font-size: 1.1rem;
  margin-right: 10px;
}
</style>